export default {
    getModelEtiq: (state) => {
        return state.etiqueta
    }
}